/**
 * @generated SignedSource<<3d4034604660336ac2968062613b31e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TVTodoPopovers_todo$data = {
  readonly assignedRoles: ReadonlyArray<{
    readonly id: string;
    readonly role: {
      readonly id: string;
      readonly team: {
        readonly id: string;
      };
    };
  }>;
  readonly id: string;
  readonly teams: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditPrioPopover_todo" | "TodoEditTagsPopover_todo">;
  readonly " $fragmentType": "TVTodoPopovers_todo";
};
export type TVTodoPopovers_todo$key = {
  readonly " $data"?: TVTodoPopovers_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVTodoPopovers_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TVTodoPopovers_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditPrioPopover_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditTagsPopover_todo"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "team",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "d0811534aea79afdfa8896c140eb5ecc";

export default node;
